import * as Cookies from 'js-cookie'

export const getUserEmailFromCookies = () => {
  return Cookies.get('userEmail')
}

export const getUserIPAddressFromCookies = () => {
  return Cookies.get('userIPAddress')
}

export const getUserFirstNameFromCookies = () => {
  return Cookies.get('userFirstName')
}

export const getUserLastNameFromCookies = () => {
  return Cookies.get('userLastName')
}

export const getPhoneNumberFromCookies = () => {
  return Cookies.get('userPhoneNumber')
}

export const getCityFromCookies = () => {
  return Cookies.get('userCity')
}

export const getStateFromCookies = () => {
  return Cookies.get('userState')
}
